var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVectorArchived(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 15.841L13.2215 12.1206L12.425 11.3241L10.0625 13.6866V8.39912H8.9375V13.6866L6.575 11.3241L5.7785 12.1206L9.5 15.841ZM1.625 5.284V17.1831C1.625 17.3849 1.68987 17.5506 1.81962 17.6804C1.94937 17.8101 2.11512 17.875 2.31687 17.875H16.6831C16.8849 17.875 17.0506 17.8101 17.1804 17.6804C17.3101 17.5506 17.375 17.3849 17.375 17.1831V5.284H1.625ZM2.49125 19C1.98725 19 1.52937 18.7941 1.11762 18.3824C0.705875 17.9699 0.5 17.5124 0.5 17.0099V4.92287C0.5 4.70312 0.534875 4.49687 0.604625 4.30412C0.675125 4.11062 0.780125 3.9325 0.919625 3.76975L2.67238 1.66375C2.83513 1.44475 3.03875 1.27938 3.28325 1.16763C3.52775 1.05588 3.79025 1 4.07075 1H14.8865C15.167 1 15.4332 1.05588 15.6852 1.16763C15.9365 1.28013 16.1435 1.4455 16.3062 1.66375L18.0804 3.8125C18.2199 3.97525 18.3249 4.15713 18.3954 4.35813C18.4651 4.55838 18.5 4.76838 18.5 4.98813V17.0087C18.5 17.5112 18.2941 17.9688 17.8824 18.3813C17.4699 18.793 17.0124 18.9989 16.5099 18.9989L2.49125 19ZM2.0525 4.159H16.925L15.4288 2.3635C15.356 2.29075 15.2728 2.233 15.179 2.19025C15.0852 2.14675 14.9878 2.125 14.8865 2.125H4.091C3.9905 2.125 3.893 2.14675 3.7985 2.19025C3.7055 2.233 3.623 2.29075 3.551 2.3635L2.0525 4.159Z",
    fill: "#919EAB",
    stroke: "#919EAB",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorArchived);
export default __webpack_public_path__ + "static/media/Vector-archived.3fcfa135436616de5d18d5697da06b28.svg";
export { ForwardRef as ReactComponent };